import { render, staticRenderFns } from "./DetailsManager.vue?vue&type=template&id=3275225c&"
import script from "./DetailsManager.vue?vue&type=script&lang=js&"
export * from "./DetailsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetailsManager.vue"
export default component.exports